import React from 'react';
import { AreaSVGProps } from '../VehiclePaintMeasurement.types';

export const AreaB_Hatchback_Left: React.FC<AreaSVGProps> = ({
  fill = '#148B4D',
  stroke = '#148B4D',
  strokeWidth = 2,
  fillOpacity = 0.5,
  className = '',
}) => {
  return (
    <svg
      width="107"
      height="217"
      viewBox="0 0 107 217"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <filter
          id="filter_area_b_hatchback_left"
          x="0"
          y="0"
          width="107"
          height="217"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
      <g filter="url(#filter_area_b_hatchback_left)">
        <path
          d="M106.772 212.325C102.285 214.804 95.8361 216.693 89.8906 216.722H89.8379L89.7861 216.723C74.2016 217.203 55.4288 214.397 39.4932 210.95C31.555 209.233 24.3888 207.372 18.7646 205.716C13.0549 204.034 9.19634 202.638 7.66699 201.877C6.36694 201.205 6.00259 200.134 5.89551 199.588C4.57231 159.345 3.0762 109.844 1.91016 70.3693C1.32589 50.5894 0.825096 33.3274 0.469735 21.0109C0.292057 14.8527 0.15046 9.93033 0.0537204 6.54802C0.0339418 5.8565 0.0160065 5.22932 9.4756e-06 4.66912C24.1907 -0.122215 62.5724 -2.23527 93.1748 3.27556C93.2079 3.698 93.2449 4.16137 93.2842 4.66326C93.506 7.4964 93.8236 11.5628 94.207 16.4953C94.9739 26.3608 96.0034 39.6907 97.0547 53.549C99.1613 81.3188 101.343 111.062 101.687 119.44L101.688 119.481V119.485C101.689 119.487 101.689 119.491 101.689 119.496C101.69 119.506 101.69 119.522 101.691 119.541C101.693 119.581 101.696 119.64 101.7 119.717C101.708 119.873 101.72 120.104 101.735 120.406C101.766 121.011 101.813 121.9 101.871 123.035C101.988 125.306 102.157 128.565 102.362 132.516C102.773 140.418 103.332 151.09 103.924 162.172C104.988 182.106 106.164 203.458 106.772 212.325Z"
          fill={fill}
          fillOpacity={fillOpacity}
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          shapeRendering="crispEdges"
        />
      </g>
    </svg>
  );
};
